<script lang="ts" setup>
/* Types */
import { Product } from '@/types/api/api-v3/make-wok'

/* Components */
import WokProductSelectItem from '@/components/Wok/WokProductSelectItem.vue'

const props = defineProps({
  products: {
    type: Array as PropType<Product[]>,
    required: true,
  },
  currency: {
    type: String,
    required: true,
  },
  value: {
    type: Number,
    required: false,
    default: null,
  },
})

const emits = defineEmits(['input'])

const selectProduct = (id: number) => emits('input', id)
</script>

<template>
  <div class="products">
    <wok-product-select-item
      v-for="product in products"
      :key="product.id"
      :name="product.name"
      :image="product.image"
      :composition="product.marking_composition"
      :price="product.price"
      :currency="currency"
      :is-selected="product.id === props.value"
      @click-image="selectProduct(product.id)"
    />
  </div>
</template>

<style lang="scss" scoped>
.products {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: -20px;
  margin-left: -25px;

  @include media('>=desktop-mini') {
    margin-bottom: -35px;
    margin-left: -40px;
  }
}
</style>
